export default {
  maxAmount: 999999999,
  defaultUniqueId: '00000000-0000-0000-0000-000000000000'
}



// WEBPACK FOOTER //
// ./src/components/_modules/I2P/models/line-item-constants.js